export default {
    methods: {
        getOfferText(offerItem, currentBalance) {
            let offerTextTops = [],
                offerTextBottoms = [];

            switch (offerItem.type) {
                case 'full-settlement':
                    if (! offerItem.plan.max_payment_choices || offerItem.plan.max_payment_choices === 1) {
                        offerTextTops.push(
                            `Pay ${this.$root.$options.filters.money(offerItem.payment)}`
                        );
                    } else if (offerItem.plan.max_payment_choices === 2) {
                        offerTextTops.push(
                            `Pay ${this.$root.$options.filters.money(offerItem.payment)} in 1 or 2 payments`
                        );
                    } else if (offerItem.plan.max_payment_choices > 2) {
                        offerTextTops.push(
                            `Pay ${this.$root.$options.filters.money(offerItem.payment)} in up to ${offerItem.plan.max_payment_choices} payments`
                        );
                    }

                    if (offerItem.discount > 0) {
                        offerTextBottoms.push(
                            `${offerItem.discount}% off, that's a savings of ${this.$root.$options.filters.money(offerItem.savings)}!`
                        );
                    }

                    break;
                case 'sliding-scale':
                    offerTextTops.push(
                        `Pay ${this.$root.$options.filters.money(offerItem.payment)} in up to ${this.offerItem.plan.max_payment_choices} payments`
                    );

                    offerTextBottoms.push(
                        'Popular Payment Plans'
                    );

                    break;
                case 'full':
                    offerTextTops.push(
                        `One time payment of ${this.$root.$options.filters.money(offerItem.payment)}`
                    );

                    offerTextBottoms.push(
                        'No penalty for early payoff!'
                    );

                    break;
                case 'settlement':
                    if (offerItem.settlement_allowed) {
                        offerTextTops.push(
                            `One time payment of ${this.$root.$options.filters.money(offerItem.offer)}`
                        );

                        if (offerItem.discount > 0) {
                            offerTextBottoms.push(
                                `${offerItem.discount}% off, that's a savings of ${this.$root.$options.filters.money(offerItem.savings)}!`
                            );
                        } else {
                            offerTextBottoms.push(
                                `On total balance of ${this.$root.$options.filters.money(currentBalance)}`
                            );
                        }
                    }

                    break;
                case 'settlement-payments':
                    if (! offerItem.plan.max_payment_choices && offerItem.payments) {
                        offerTextTops.push(
                            `${offerItem.payments} payments of ${this.$root.$options.filters.money(offerItem.payment)}`
                        );
                    } else if (offerItem.plan.max_payment_choices && offerItem.plan.max_payment_choices === 1) {
                        offerTextTops.push(
                            `Pay ${this.$root.$options.filters.money(offerItem.payment)}`
                        );
                    } else if (offerItem.plan.max_payment_choices && offerItem.plan.max_payment_choices === 2) {
                        offerTextTops.push(
                            `Pay ${this.$root.$options.filters.money(offerItem.payment)} in 1 or 2 payments`
                        );
                    } else if (offerItem.plan.max_payment_choices && offerItem.plan.max_payment_choices > 2) {
                        offerTextTops.push(
                            `Pay ${this.$root.$options.filters.money(offerItem.payment)} in up to ${offerItem.plan.max_payment_choices} payments`
                        );
                    }

                    if (offerItem.discount > 0) {
                        offerTextBottoms.push(
                            `${offerItem.discount}% off, that's a savings of ${this.$root.$options.filters.money(offerItem.savings)}!`
                        );

                        offerTextBottoms.push(
                            `On total balance of ${this.$root.$options.filters.money(currentBalance)}`
                        )
                    }

                    break;
                case 'full-balance':
                    offerTextTops.push(
                        `One time payment of ${this.$root.$options.filters.money(offerItem.payment)}`
                    );

                    offerTextBottoms.push(
                        `On total balance of ${this.$root.$options.filters.money(currentBalance)}`
                    );

                    break;
                case 'low-payments':
                    if (offerItem.amount === 100) {
                        offerTextTops.push(
                            `Payments of ${this.$root.$options.filters.money(offerItem.amount)}`
                        );
                    } else {
                        offerTextTops.push(
                            `Low payments of ${this.$root.$options.filters.money(offerItem.amount)} or more`
                        );
                    }

                    offerTextBottoms.push(
                        `On total balance of ${this.$root.$options.filters.money(currentBalance)}`
                    );

                    break;
                case 'low-payments-multi':
                    offerTextTops.push(
                        `Payments as low as ${this.$root.$options.filters.money(offerItem.amounts[0])}`
                    );

                    offerTextBottoms.push(
                        `On total balance of ${this.$root.$options.filters.money(currentBalance)}`
                    );

                    break;
                case 'low-payments-multi-with-dp':
                    offerTextTops.push(
                        `Payments as low as ${this.$root.$options.filters.money(offerItem.amounts[0])}`
                    );

                    offerTextTops.push(
                        `With down payment of ${this.$root.$options.filters.money(offerItem.down_payment)}`
                    );

                    offerTextBottoms.push(
                        `On total balance of ${this.$root.$options.filters.money(currentBalance)}`
                    );

                    break;
            }

            return {
                offerTextTops,
                offerTextBottoms
            };
        }
    }
};